//import content types
import contenttype from '../templates/contenttype';
import Standard from '../content/standard';

export default class Tags {
  constructor(el) {
    this.element = el;
    this.entries = [];
    this.tags = [];
    this.rootPath = this.element.dataset.rooturl;
    this.feedURL = '/tags/all/';

    this.getFeed().then(() => {
      //this.element.insertAdjacentHTML('beforeend', this.displayPage(this.entries, this.getTags(this.entries)));
      this.init();
    });
  }

  async getFeed() {
    try {
      const response = await fetch(this.feedURL);
      if (!response.ok) {
        throw new Error(
          `Failed to fetch feed: ${response.status} ${response.statusText}`
        );
      }
      const data = await response.json();
      this.entries = data.entries || [];
      console.log(this.entries);
    } catch (error) {
      console.error('An error occurred while fetching the feed:', error);
    }
  }

  getAllEntries() {
    return this.entries;
  }

  getEntriesByTag(entries, tag) {
    return entries.filter((entry) => {
      return entry.tags ? entry.tags.split(',').includes(tag) : false;
    });
  }

  getEntriesByRootPath(entries, rootPath) {
    console.log(entries);
    console.log(rootPath);
    return entries.filter((entry) => {
      return entry.tag_section_details
        ? entry.tag_section_details.path === rootPath
        : false;
    });
  }

  getTags(entries) {
    //create a list of all unique tags from entries array using a Set
    let tags = new Set();
    entries.forEach((entry) => {
      if (entry.tags) {
        entry.tags.split(',').forEach((tag) => {
          tags.add(tag);
        });
      }
    });
    return Array.from(tags);
  }

  getTagsByRootPath(entries, rootPath) {
    return this.getTags(this.getEntriesByRootPath(entries, rootPath));
  }

  getTagsByEntry(entry) {
    return entry.tags ? entry.tags.split(',') : [];
  }

  displayEntries(entries) {
    let html = '';
    entries.forEach((entry) => {
      if (entry.name) {
        let tagslist = '';
        if (entry.tags) {
          tagslist = `<ul class="tags-list">`;
          entry.tags.split(',').forEach((tag) => {
            tagslist += `
                  <li class="tag">
                    <a href="?tags=${tag}">${tag}</a>
                  </li>
                `;
          });
          tagslist += '</ul>';
        }

        html += `
            <div class="row">
              <div class="column large-12">
                <div class="result">
                  <div class="tag-entry">
                    <h3>${entry.section_name}</h3>
                    <p><a href="${entry.url}">${entry.url}</a></p>
                    <p>${entry.summary}</p>
                    ${tagslist}
                  </div>
                </div>
              </div>
            </div>
            `;
      }
    });
    return html;
  }

  displayTags(tags) {
    let html = '<h2>Related tags</h2><ul class="tags-list">';
    tags.forEach((tag) => {
      html += `
            <li class="tag">
              <a href="?tags=${tag}">${tag}</a>
            </li>
          `;
    });
    html += '</ul>';
    return html;
  }

  displayPage(entries, tags, heading) {
    return contenttype.standard({
      heading: heading,
      content: this.displayEntries(entries),
      quicklinks: this.displayTags(tags),
    });
  }

  watchURLParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const tag = urlParams.get('tags');
    if (tag) {
      //alert(tag);
      this.element.insertAdjacentHTML(
        'beforeend',
        this.displayPage(
          this.getEntriesByTag(this.entries, tag),
          this.getTagsByRootPath(this.entries, this.rootPath),
          `Showing: ${tag} <span class="tags-show-all"><a href="?tags=">show all</a></span>`
        )
      );
    } else {
      //alert("no tag");
      this.element.insertAdjacentHTML(
        'beforeend',
        this.displayPage(
          this.getEntriesByRootPath(this.entries, this.rootPath),
          this.getTagsByRootPath(this.entries, this.rootPath),
          `All tags`
        )
      );
    }
  }

  init() {
    //check for url params
    this.watchURLParams();
    [
      ...document.querySelectorAll('.standardContent:not(.splashwrapper)'),
    ].forEach((el) => {
      new Standard(el);
    });
    //if url params change run watchURLParams
    window.addEventListener('popstate', () => {
      this.watchURLParams();
    });
  }
}
